"use client";
import { NavigationArrowWrapper } from "@areahub/ui/components/navigation-arrow/navigation-arrow-wrapper";
import { BlockquoteComponent } from "@areahub/ui/marketing/blockquote-component";
import { PodcastNewsBrief } from "@areahub/ui/marketing/podcast-news-brief";
import { Box, Divider, Heading, Stack } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { richTextRenderers } from "components/individuals/mdx-components";
import type { LegalPost } from "../../../app/individuals/legal/[slug]/page";

type Props = {
  post: LegalPost;
};
export default function LegalPost({ post }: Props) {
  return (
    <>
      <Box maxW="1440px" mx="auto" px="5" my="24">
        <Stack as="article" flexDirection="row" justifyContent="center">
          <Box
            maxW="container.md"
            mx="auto"
            px={{ base: "6", md: "8" }}
            alignSelf="flex-start"
            mt="0"
          >
            {/* title and short excerpt */}
            <Heading as="h1" size="2xl" mb="4" letterSpacing="unset">
              {post.title}
            </Heading>
            <Divider />
            <Stack
              flexDirection="column"
              flex="auto"
              alignItems="flex-start"
              spacing={{
                base: "6",
              }}
            >
              <RichText
                content={post.content?.json}
                renderers={{
                  ...richTextRenderers,
                  embed: {
                    BlockquoteComponent: ({ description }) => (
                      <BlockquoteComponent>
                        <RichText
                          content={description.raw}
                          renderers={richTextRenderers}
                        />
                      </BlockquoteComponent>
                    ),
                    PodcastNewsBrief: ({ link }) => (
                      <PodcastNewsBrief link={link} />
                    ),
                  },
                }}
              />
            </Stack>
          </Box>
        </Stack>
      </Box>
      <NavigationArrowWrapper />
    </>
  );
}
